import { render, staticRenderFns } from "./news_education.vue?vue&type=template&id=24bf3dfc&"
import script from "./news_education.vue?vue&type=script&lang=js&"
export * from "./news_education.vue?vue&type=script&lang=js&"
import style0 from "./news_education.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports